module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_10X_Section1.86051e8b.png";